// AWS Amplify Configuration Template - autogenerated at deploy time
/* eslint no-template-curly-in-string: 0*/
const config = {
  s3: {
    REGION: "eu-central-1",
    BUCKET: "app-be-investor-844375376115-uploads",
  },
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://hvbxmd0vif.execute-api.eu-central-1.amazonaws.com/prod/v1",
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_EBRVMZ0CY",
    APP_CLIENT_ID: "1hfc2u7inu9dr7b1a6nqes3t61",
    IDENTITY_POOL_ID: "eu-central-1:94f73078-fcbd-4bff-8d00-83d720d2e447",
  },
  locales: {
    URL: "https://locales.platform.prod.beteiligungsboerse.net",
  },
  datastore: {
    URL: "https://datastore.platform.prod.beteiligungsboerse.net",
  },
  registration: {
    URL: "https://registration.platform.prod.beteiligungsboerse.net/v1",
    NEXT_PAGE: "https://app.investor.prod.beteiligungsboerse.net",
    TO_REFERRER: "https://www.beteiligungsboerse.eu/register-success/",
  },
  product: {
    PRODUCT_KEY: "investor",
  },
};

export default config;
